import axios from "../../config/axiosConfig";
import { CREATE_JOURNAL_VOUCHER, GET_JOURNAL_VOUCHER, GET_JOURNAL_VOUCHER_PAGE, JOURNAL_VOUCHER_REQUEST, DELETE_JOURNAL_VOUCHER,
    UPDATE_JOURNAL_VOUCHER, JOURNAL_VOUCHER_REQUEST_FAILURE, JOURNAL_VOUCHER_REQUEST_SUCCESS } from "../types";

export const getJournalVouchersWithPagination = (page, limit, include, searchStr, searchCols, where, showTaxJv) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOURNAL_VOUCHER_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, showTaxJv, search: searchStr, searchCols, where,
        includeAttr: 'Credit_Account_Id,Debit_Account_Id'
      };
      return axios.get("/journal-voucher/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_JOURNAL_VOUCHER_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getJournalVouchers = (include, finyear) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: JOURNAL_VOUCHER_REQUEST });
            const { auth } = getState();
            const fin = finyear || auth.finyear; 
            let params = { customerId: auth?.user?.Customer_Id, finyearId: fin?.id, };
            // if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            // }
            if (include) {
                params = { ...params, include, showTaxJv: true };
            }
            return axios.get('/journal-voucher/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_JOURNAL_VOUCHER, payload: response.data?.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getValidatedIncrementedVchNoJournalVoucher = (currentVchNo, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/journal-voucher/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getJournalVoucherById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: JOURNAL_VOUCHER_REQUEST });
    
      return axios.get(`/journal-voucher/get/${id}`).then((response) => {
        dispatch({ type: JOURNAL_VOUCHER_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getJournalVouchersByRange = (billId, from, to, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/journal-voucher/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createJournalVoucher = (journalVoucher, finyear) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const fin = finyear || auth.finyear; 
            dispatch({ type: JOURNAL_VOUCHER_REQUEST });
            return axios.post('/journal-voucher/add', journalVoucher,
                { params: {
                    userId: auth.user?.id,
                    companyId: auth.company?.id,
                    customerId: auth?.user?.Customer_Id,
                    finyearId: fin?.id
                }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_JOURNAL_VOUCHER, payload: response.data });
                    } else {
                        dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: 'Group create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateJournalVoucher = (id, data, finyear) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const fin = finyear || auth.finyear; 

            dispatch({ type: JOURNAL_VOUCHER_REQUEST });
            return axios.put('/journal-voucher/update', { id, data },
                { params: {
                    userId: auth.user?.id,
                    companyId: data.Company_Id || auth.company?.id,
                    customerId: data.Customer_Id || auth?.user?.Customer_Id,
                    finyearId: data.Finyear_Id || fin?.id
                }
            }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_JOURNAL_VOUCHER, payload: { id, data: response.data } });
                } else {
                    dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: 'Group update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteJournalVoucher = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: JOURNAL_VOUCHER_REQUEST });
            return axios.delete(`/journal-voucher/delete/${id}`).then((response) => {
                if (response.data) {
                  dispatch({ type: DELETE_JOURNAL_VOUCHER, id: id });
                  const include = ['id', 'JV_No', 'Date', 'Credit_Account_Id', 'Debit_Account_Id', 'Cr_Amount', 'Description1', 'Description2', 'Is_Not_Show_In_TDS_Report', 'Bill_Adj_Ref', 'Tax_JV_Ref'].join(',');
                  const searchCols = ['JV_No'].join(',');
                  const { transaction: { journalVoucher: { page, pageSize, search, where, showTaxJv } = {} } } = getState();
                  dispatch(getJournalVouchersWithPagination(page, pageSize, include, search, searchCols, where, showTaxJv));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: JOURNAL_VOUCHER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};
